import { createFileRoute } from '@tanstack/react-router'
import { InterviewScoringList } from '@/features/interview-scoring'

export const Route = createFileRoute('/_authenticated/admin/interview-scoring/')({
  component: InterviewScoringList,
})
